module.exports = __webpack_public_path__ + "img/UserLoginCodes.8f855e2f.svg";